import { useState } from "react";

import { useAuth } from "../auth/AuthProvider";
import { errorMessage } from "../components/ErrorAlert";

const codePoints = (value: string) => [...value].length;

/** DR-9: passwords are not trimmed or normalized. */
const validate = (current: string, next: string, confirm: string) => {
  if (codePoints(next) < 8 || codePoints(next) > 128 || next.includes("\0")) {
    return "비밀번호는 8~128자로 입력해 주세요.";
  }
  if (next !== confirm) {
    return "새 비밀번호가 서로 다릅니다.";
  }
  if (next === current) {
    return "현재 비밀번호와 다른 비밀번호를 입력해 주세요.";
  }
  return null;
};

export const PasswordPage = () => {
  const auth = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [pending, setPending] = useState(false);

  return (
    <section className="canvaschool-auth">
      <h1>비밀번호 변경</h1>
      <form
        aria-label="비밀번호 변경"
        className="canvaschool-form"
        onSubmit={async (event) => {
          event.preventDefault();
          const problem = validate(current, next, confirm);
          setDone(false);
          if (problem) {
            setError(problem);
            return;
          }
          setPending(true);
          setError(null);
          try {
            await auth.api.changePassword(current, next);
            // Every session, including this one, is revoked by the server.
            auth.passwordChanged();
          } catch (failure) {
            setError(errorMessage(auth.handleError(failure)));
          } finally {
            setPending(false);
          }
        }}
      >
        <div className="canvaschool-field">
          <label htmlFor="canvaschool-current-password">현재 비밀번호</label>
          <input
            id="canvaschool-current-password"
            type="password"
            autoComplete="current-password"
            value={current}
            onChange={(event) => setCurrent(event.target.value)}
          />
        </div>
        <div className="canvaschool-field">
          <label htmlFor="canvaschool-new-password">새 비밀번호</label>
          <input
            id="canvaschool-new-password"
            type="password"
            autoComplete="new-password"
            value={next}
            onChange={(event) => setNext(event.target.value)}
          />
        </div>
        <div className="canvaschool-field">
          <label htmlFor="canvaschool-confirm-password">새 비밀번호 확인</label>
          <input
            id="canvaschool-confirm-password"
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(event) => setConfirm(event.target.value)}
          />
        </div>
        {error && (
          <p className="canvaschool-error--box canvaschool-error" role="alert">
            {error}
          </p>
        )}
        {done && (
          <p className="canvaschool-success" aria-live="polite">
            비밀번호를 변경했습니다.
          </p>
        )}
        <button
          type="submit"
          className="canvaschool-btn-primary"
          disabled={pending}
        >
          변경
        </button>
      </form>
    </section>
  );
};
